import * as yup from "yup";

import { ICreateBankTransferBeneficiary } from "../../../interfaces-and-types";

export const createBankTransferBeneficiarySchema: yup.SchemaOf<ICreateBankTransferBeneficiary> =
  yup
    .object({
      country: yup.string().required("Country is required"),
      currency: yup.string().required("Currency is required"),
      bank_code: yup.string().required("Bank is required"),
      account_number: yup.string().required("Account Number is required"),

      full_name: yup
        .string()
        .max(200, "Max length of alias is 200 characters")
        .nullable()
        .optional(),
      email: yup.string().email().nullable().optional(),
      phone_number: yup
        .string()
        .max(100, "Max length of phone no is 100 characters")
        .nullable()
        .optional(),
      description: yup
        .string()
        .max(300, "Max length of description is 300 characters")
        .nullable()
        .optional(),
    })
    .required();
